import React from "react";
import "./index.css";
import Navbar from "../../Shared/Navbar/Navbar";
import Footer from "../../Shared/Footer/Footer";
import PrayerTimesCard from "./Time";
import FivePillars from "./pillar";
import IslamicOccasions from "./Event";
import Donation from "./Donation";
import MoshjidCommittee from "./Member";
import Gallery from "./Gallery";
import Vlog from "./Vlog";
import GoogleMapEmbed from "./Location";
const Home = () => {
  return (
    <>
      <div className="bg-cover bg-center bg-no-repeat  w-full h-screen bg-bannerImg">
        <div className="absolute top-0 left-0 w-full z-10">
          <Navbar />
        </div>
      </div>
      <PrayerTimesCard></PrayerTimesCard>
      <FivePillars></FivePillars>
      <IslamicOccasions></IslamicOccasions>
      <Donation></Donation>
      <MoshjidCommittee></MoshjidCommittee>
      <Gallery></Gallery>
      <Vlog></Vlog>
      <GoogleMapEmbed
        latitude={22.3816157}
        longitude={91.8167071}
        placeName="Our Location"
      />

      <Footer></Footer>
    </>
  );
};

export default Home;
